<template>
	<section class="join-donor">
		<div class="max-width-1000">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item to="/join">加入金枝</el-breadcrumb-item>
				<el-breadcrumb-item>金枝椅友</el-breadcrumb-item>
			</el-breadcrumb>
			<br>
			<quote-title label="金枝椅友" />
			<article>
				<h2 class="theme_text">感謝一路相伴</h2>
				<p>金枝，從土地長出來。<br>
				我們說的故事，是這座島嶼的記憶、慾望與吶喊。<br>
				舞台上的每一次燈亮，背後都需要有人一起撐著。</p>
				<p>【金枝椅仔會】，不只是一張折扣卡，而是一群願意讓台灣戲劇繼續發聲的人。<br>
				加入金枝椅仔會，不只是支持劇團，更是選擇站在文化與認同這一邊。<br>
				如果您相信這片土地的故事值得被說，歡迎成為金枝椅友。讓劇場繼續長出屬於我們的聲音。
				</p>
				<h3 class="theme_text">誠摯邀請您加入【金枝椅仔會】
					<br>年度捐款1000元(含)以上，即可享有金枝椅友專屬權益。
					<br>金枝演社，由衷感謝您的支持！
				</h3>
				<br>
				<p>
				※「學生椅友」方案：<br>
				如您為學生身份，年度只要贊助500元（含）以上，即享有相同權益。<br>
				於加入或續約時請提供相關在學證明或學生證影本等證明文件。
				</p>
			</article>
			<br>
			<article>
				<h2 class="theme_text">金枝椅友權益</h2>
				<hr>
				<p>感謝您的贊助，金枝將提供如下的優惠與服務：
					<ol>
						<li>訂購金枝主辦之演出節目票券及周邊出版品，享最低優惠折扣。</li>
						<li>贊助年度享有金枝主辦之演出節目票劵，不限票價五折優惠乙次（限購1張），詳細使用辦法以金枝演社相關公告為主。</li>
						<li>金枝主辦之演出節目享優先預購及選位。</li>
						<li>邀請參與金枝安排的相關活動（觀摩彩排預演、椅友特別聚會、導覽或幕後活動等）。</li>
						<li>您的名銜將刊印於金枝節目單及相關出版品的感謝頁。</li>
						<li>致贈專屬金枝椅友卡。</li>
						<li>優先收到金枝最新演出及活動訊息（手機簡訊、電子報、DM）。</li>
						<li>參加金枝主辦之表演／推廣課程享有特別優惠。</li>
						<li>為您開立可供年度申報抵稅的捐款收據。</li>
					</ol>
				</p>
			</article>
			<br>
			<article>
				<h2 class="theme_text">捐款方式</h2>
				<hr>
				<ol>
					<li>郵政劃撥：
						<br>帳號: 19698402
						<br>戶名: 金枝演社劇團
						<br>※ 請於備註欄位填寫「金枝椅仔會捐款」</li>
					<li>銀行匯款／ATM轉帳：
						<br>銀行別: 合作金庫銀行（006）大稻埕分行
						<br>帳號: 0050 717 134653
						<br>※ 請於匯款後來電或email告知匯款帳號末5碼</li>
					<li>支票：
						<br>支票抬頭請開列：金枝演社劇團
						<br>請以掛號郵寄至「24945新北市八里區龍米路二段117巷39-1號，金枝演社劇團收」。</li>
				</ol>
				<h3 class="theme_text">感謝您加入金枝椅友！</h3>
				<p>您可以選擇線上填表，並請填寫下列資料 或 <a href="/GBT_support.docx" target="_blank" download="金枝椅友捐款單.docx" class="theme_text"><b><u>下載捐款單</u></b></a>，以傳真或E-mail回覆給我們，若有任何需求，煩請與我們聯繫，金枝演社隨時為您服務。</p>
				<p>金枝椅友服務專線：<a href="tel:+886-2-6637-7987"><u>(02) 6637-7987</u></a> 洪筱欣
					<br>Email：<a href="mailto:gbt1993@gmail.com"><u>gbt1993@gmail.com</u></a>
					<br>Fax：02-2618-6842</p>
			</article>
			<br>
			<article>
				<h2 class="theme_text">我要加入</h2>
				<hr>
				<br>
				<member-form-readonly />
				<donor-form ref="ruleForm" />
				<br>
				<div class="center">
					<el-button type="theme" round @click="handleApplyUpgrade()">立即加入</el-button>
				</div>
			</article>
		</div>
	</section>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
	components: {
		MemberFormReadonly: () => import("@/components/join/member-form-readonly"),
		DonorForm: () => import("@/components/join/donor-form")
	},
	methods: {
		...mapActions("auth", ["_applyUpgrade"]),
		async handleApplyUpgrade() {
			try {
				const { message } = await this._applyUpgrade(await this.$refs["ruleForm"].validate())
				this.$alert(message, {
					type: "success",
					dangerouslyUseHTMLString: true
				}).then(() => {
					this.$router.push("/join");
				});
			} catch (error) {
				this.$message.error(error);
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.join-donor {
	padding: 50px 5%;
}
</style>